import {
  BulkActionContainerCol,
  Col,
  Table,
  TableActionBarRow,
} from "melco-ui";
import { useTranslation } from "react-i18next";
import {
  BulkActionCount,
  EodMelcoEodModelsEodSetting,
  FormattedDate,
  //any,
  Search,
  ViewContext,
  useTableSelection,
} from "melco-shared-logic";
import { TFunction } from "i18next";
import { useEodSettings } from "../../hooks/settings/useEodSettings";
import { BulkActionDeleteEodSettings } from "./BulkActionDeleteEodSettings";
import { useEffect } from "react";


export const EodSettingsListColumns = (
  t: TFunction<"ns1">,
  context: ViewContext = ViewContext.List
) => {
  return [
    {
      title: t("eodsettings.list.columns.partner"),
      key: "partner",
      dataIndex: "partner",

    },
    {
      title: t("eodsettings.list.columns.name"),
      key: "name",
      dataIndex: "name",
      //sorter: true,
    },
  ];
};

export const EodSettingsList: React.FC<{ onDataLoaded?: (isEmpty: boolean) => void }> = ({ onDataLoaded }) => {
  const {
    isLoading,
    isFetching,
    data,
    isPreviousData,
    errorComponent,
    onTableConfigChange,
    pagination,
    searchQueryChange,
    refetch,
  } = useEodSettings();

  // Notify parent when data changes
  useEffect(() => {
    if (data) {
      onDataLoaded?.(data.length !== 0);
    }
  }, [data]);

  const { t } = useTranslation();

  // const [isResendAvailable, resendInvite, isResendingForEodSettingId] =
  //   useResendInvite();

  const { selectedRowKeys, setSelectedRowKeys, rowSelection, onRow } =
    useTableSelection<EodMelcoEodModelsEodSetting>((row) => { });

  const columns = [
    ...EodSettingsListColumns(t),
    {
      title: t("eodsettings.list.columns.created_date"),
      key: "created_date",
      dataIndex: "created_date",
      //  sorter: true,
      render: (_: string, item: EodMelcoEodModelsEodSetting) => (
        <FormattedDate date={item.created_date} />
      ),
    },
    {
      title: t("eodsettings.list.columns.last_activity"),
      key: "last_activity",
      dataIndex: "last_activity",
      //  sorter: true,
      render: (_: string, item: EodMelcoEodModelsEodSetting) => (
        <FormattedDate date={item.last_activity} />
      ),
    },
    // {
    //   title: ("eodsettings.list.columns.status"),
    //   key: "status",
    //   dataIndex: "status",
    //   sorter: false,
    //   render: (_: string, eodSetting: any) =>
    //     eodSetting.verified_on ? (
    //       <Text type="success">{("eodsettings.list.status.active")}</Text>
    //     ) : (
    //       <Text type="warning">{("eodsettings.list.status.invited")}</Text>
    //     ),
    // },

  ];

  return (
    <>
      <TableActionBarRow>
        <Col xs={24} xl={17}>
          <Search
            onSearchInputChange={(query: string) => searchQueryChange(query)}
          />
        </Col>
        <BulkActionContainerCol>
          <BulkActionCount selectedCount={selectedRowKeys.length} />
          <BulkActionDeleteEodSettings
            selectedRowKeys={selectedRowKeys}
            setSelectedRowKeys={setSelectedRowKeys}
            refetch={refetch}
          />
        </BulkActionContainerCol>
      </TableActionBarRow>
      <Table
        showSorterTooltip={false}
        loading={isPreviousData ? isFetching : isLoading}
        dataSource={data}
        columns={columns}
        onChange={onTableConfigChange}
        pagination={pagination}
        rowKey="name+url+partner"
        rowSelection={rowSelection}
        onRow={onRow}
        noDataMessage={t("eodsettings.list.empty")}
        errorComponent={errorComponent}
      />
    </>
  );
};
